import type { GridOptions } from "ag-grid-enterprise";
import type { AgGridReactProps } from "ag-grid-react";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";
import { theme } from "./DataTableTheme";

export type DataTableProps = AgGridReactProps & {
  ref?: React.Ref<AgGridReact>;
};

export function DataTable(props: DataTableProps) {
  // Allow consumers to override defaults via props.gridOptions
  const { gridOptions, ...rest } = props;

  const defaultGridOptions: GridOptions = useMemo(
    () => ({
      // Layout & sizing
      headerHeight: 36,
      // Row selection
      cellSelection: true,
      rowSelection: {
        mode: "singleRow",
        enableClickSelection: true,
        enableSelectionWithoutKeys: true,
        checkboxes: false,
        headerCheckbox: false
      },

      // Crosshairs
      columnHoverHighlight: true,

      // Column defaults
      suppressAggFuncInHeader: true,
      groupLockGroupColumns: -1,
      defaultColDef: {
        resizable: true,
        sortable: true,
        flex: 1,
        minWidth: 85
      },

      // Clipboard & data handling
      suppressClipboardPaste: false,
      processDataFromClipboard: (params) => params.data,

      // UX
      tooltipShowDelay: 250,

      // Sorting & Excel export
      excelStyles: [
        { id: "integerType", numberFormat: { format: "0" } },
        { id: "numberType", numberFormat: { format: "0.00" } }
      ]
    }),
    []
  );

  // Merge with incoming gridOptions so consumers can override
  const mergedGridOptions = useMemo<GridOptions>(
    () => ({ ...defaultGridOptions, ...gridOptions }),
    [defaultGridOptions, gridOptions]
  );

  return (
    <AgGridReact theme={theme} gridOptions={mergedGridOptions} {...rest} />
  );
}
